import { render, staticRenderFns } from "./NcmForm.vue?vue&type=template&id=f2dd2196"
import script from "./NcmForm.vue?vue&type=script&lang=js"
export * from "./NcmForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports